import {
  AuthForgotPassword,
  AuthLogin,
  AuthUpdateAccount,
} from "@components/resolvers/auth.resolvers";
import Cookies from "js-cookie";
import moment from "moment";
import { BaseService } from "./base.service";
import { AuthLoginResponse } from "./dtos/auth.dto";
import { BaseResponse } from "./dtos/base.dto";

// A `Secure` cookie is silently dropped by the browser on any non-HTTPS
// origin except the literal `localhost`/`127.0.0.1` (browsers special-case
// those as a secure context). Local dev over a LAN IP (see AppConfig.isDevelop
// on the Flutter side) is plain HTTP and not localhost, so hardcoding `true`
// here made login "succeed" but never actually persist the session cookie.
// Deriving it from the real protocol keeps prod hardened without breaking dev.
const isSecureContext = window.location.protocol === "https:";

interface AuthServiceInterface {
  login(payload: AuthLogin): Promise<AuthLoginResponse>;
  forgotPassword(payload: AuthForgotPassword): Promise<BaseResponse<boolean>>;
  resetPassword(payload: {
    code: string;
    password: string;
  }): Promise<BaseResponse<boolean>>;
  updateAccount(payload: AuthUpdateAccount): Promise<AuthLoginResponse>;
}
export const AuthService: AuthServiceInterface = {
  login: async (payload) => {
    try {
      const request = await BaseService.request().post<AuthLoginResponse>(
        "/auth/login",
        payload
      );
      const response = request.data.data!;
      const token = response.token.type + " " + response.token.token;

      Cookies.set("token", token, {
        expires: moment(response.token.eat).toDate(),
        secure: isSecureContext,
        sameSite: "strict",
      });

      Cookies.set("redirect", response.redirect, {
        expires: moment(response.token.eat).toDate(),
        secure: isSecureContext,
        sameSite: "strict",
      });

      // androidSaveDataBiomatric(payload);

      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
  forgotPassword: async (payload) => {
    try {
      const request = await BaseService.request().post<BaseResponse<boolean>>(
        "/auth/forgot-password",
        payload
      );
      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
  resetPassword: async (payload) => {
    try {
      const request = await BaseService.request().post<BaseResponse<boolean>>(
        "/auth/reset-password",
        payload
      );
      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
  updateAccount: async (payload) => {
    try {
      const request = await BaseService.request().post<BaseResponse<boolean>>(
        "/auth/update-account",
        payload
      );

      Cookies.set("redirect", "/home/dashboard", {
        secure: isSecureContext,
        sameSite: "strict",
      });
      return BaseService.response(request);
    } catch (error: unknown) {
      return BaseService.response(error, true);
    }
  },
};
